import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

import * as DF from 'fixedassets/components/detail/field';

class AssetDetailGeneral extends Component {
  render = () => (
    <Form.Section title={this.props.t('assets.section.accountant')}>
      <div className="row">
        <DF.Relation label={'assets.fields.account'} value={this.props.asset._account} />
        <DF.Relation label={'assets.fields.subaccount'} value={this.props.asset._subaccount} />
        <DF.Date label={'assets.fields.startDate'} value={this.props.asset.startDate} />
        <DF.Catalog label={'assets.fields.status'} value={this.props.asset._status} />
        <DF.Relation
          label={'assets.fields.financialDepreciation'}
          value={this.props.asset._financialDepreciation}
        />
        <DF.Relation
          label={'assets.fields.fiscalDepreciation'}
          value={this.props.asset._fiscalDepreciation}
        />
        <DF.Text label={'assets.fields.usefulLifeOriginal'} value={this.props.asset.usefulLifeOriginal} />
      </div>
    </Form.Section>
  );
}

export default translate()(AssetDetailGeneral);



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/detail/AssetDetailAccountant.js